
import { wrapWithCaller } from './wrapWithCaller';

export const getArrayOfObjectsToPrimitive = (arr, caller) => {
    if(!Array.isArray(arr)) {
        console.log(wrapWithCaller('Not an array has been provided to =getArrayToPrimitive=', caller));
        return arr;
    }
    return arr.map(value => {
        if(Object.prototype.toString.call(value) !== '[object Object]') {
            console.log(wrapWithCaller('Not a true object in an array has detected in =getArrayToPrimitive=', caller));
        } else {
            return Object.values(value).toString();
        }
    }).toString();
};